import React, { Component } from "react";
import { actions } from "../../store/index";
import PropTypes from "prop-types";

import Auction from "../auction";
import Extend from "../extend";
import Buy from "../buy";
import ReBuy from "../re-buy/ReBuy";
import Sell from "../sell";

import { Icon } from "antd";

import CtTimer from "../ct-timer";

import "./Panel.css";

const desc = [
  `1. You can rent the billboards for a period of three days. Just wait for auction
  to start and make the highest bid. Starting price is 0.01 NAS.`,
  `2. If you cant wait for auction to start, you can make direct offer to the current
   renter and if they accept it, billboards will be yours for the rest of the renting period.`,
  `3. Renter has an exclusive right to renew the rent for the next three days. Each renewal
   adds 10% to the rent price and must be done before the rent period is over.`
];

class Panel extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    infoToggle: PropTypes.bool.isRequired,
    state: PropTypes.string,
    ends: PropTypes.number,
    price: PropTypes.string,
    bid: PropTypes.object,
    isLoading: PropTypes.bool,
    currentUserKey: PropTypes.string,
    renter: PropTypes.string
  };

  noData = () =>
    !this.props.state || !this.props.bid || !this.props.currentUserKey;

  render() {
    return (
      <div className="component-Panel">
        {!this.noData() && !this.props.isLoading ? (
          <div className="panel">
            <div className="slogan">
              <h3>Do you have something to say to the world?</h3>
            </div>
            <div className="state">
              <h2>{this.props.state.toUpperCase()}</h2>
            </div>
            <CtTimer ends={this.props.ends} />
            <hr />
            <div className="actions">
              <Buy status={this.props.state} />
              {this.props.isLoading ? '' : <div><Buy state={this.props.state} /> </div>}
              {this.props.isLoading ? (
                ""
              ) : (
                <Extend
                  state={this.props.state}
                  isRenter={this.props.renter === this.props.currentUserKey}
                  price={this.props.price}
                />
              )}
              {this.props.isLoading ? (
                ""
              ) : (
                <Auction
                  state={this.props.state}
                  offer={
                    this.props.bid && this.props.bid.value
                      ? this.props.bid.value
                      : 0
                  }
                  price={this.props.price}
                  isBidder={
                    this.props.bid && this.props.bid.bidder
                      ? this.props.currentUserKey === this.props.bidder
                      : false
                  }
                />
              )}
              {this.props.isLoading ? (
                ""
              ) : (
                <Sell
                  state={this.props.state}
                  price={
                    this.props.bid && this.props.bid.value
                      ? this.props.bid.value
                      : 0
                  }
                  bidder={
                    this.props.bid && this.props.bid.bidder
                      ? this.props.bid.bidder
                      : null
                  }
                  isRenter={this.props.renter === this.props.currentUserKey}
                />
              )}
              {this.props.isLoading ? (
                ""
              ) : (
                <ReBuy
                  state={this.props.state}
                  price={this.props.price}
                  isRenter={this.props.renter === this.props.currentUserKey}
                />
              )}
            </div>
            <hr />
            <div className="three-description">
              <div className="desc--title">
                <h4>
                  For a small fee, your message will go live on Nebulas
                  blockchain. Here are the rules:
                </h4>
              </div>
              <div className="desc-list">
                <ul>{desc.map(d => <li key={d}>{d}</li>)}</ul>
              </div>
            </div>
          </div>
        ) : (
          <div className="slogan">
            Please install{" "}
            <a href="https://chrome.google.com/webstore/detail/nasextwallet/gehjkhmhclgnkkhpfamakecfgakkfkco">
              NasExtWallet
            </a>{" "}
            to use this site.
          </div>
        )}
      </div>
    );
  }
}

export default Panel;



// WEBPACK FOOTER //
// ./src/components/panel/Panel.js